document.addEventListener("DOMContentLoaded", (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const headlineParam = urlParams.get('headline');
    let title = document.querySelector(".landing-title");
    if (headlineParam) {
        title.textContent = headlineParam;
    }

    // Handle event type selection and toggle visibility of related fields
    const eventTypeSelect = document.querySelector('select#lead_event_type_id');
    let partnerNameDiv = document.querySelector('.form-group.lead_partner_name, #event-information #lead_partner_name');
    let eventTypeOtherDiv = document.querySelector('.form-group.lead_event_type_other, #event-information #lead_event_type_other');

    if (partnerNameDiv && partnerNameDiv.nodeName.toLowerCase() === 'input') {
        partnerNameDiv = partnerNameDiv.closest('tr');
    }

    if (eventTypeOtherDiv && eventTypeOtherDiv.nodeName.toLowerCase() === 'input') {
        eventTypeOtherDiv = eventTypeOtherDiv.closest('tr');
    }

    if (eventTypeSelect) {
        // Initial check on page load
        const selectedOption = eventTypeSelect.options[eventTypeSelect.selectedIndex];
        const selectedText = selectedOption ? selectedOption.text : '';
        toggleRelatedFields(selectedText);

        // Add change event listener
        eventTypeSelect.addEventListener('change', function() {
            const selectedOption = this.options[this.selectedIndex];
            const selectedText = selectedOption ? selectedOption.text : '';
            toggleRelatedFields(selectedText);
        });
    }

    function toggleRelatedFields(selectedValue) {
        // Check if the elements exist before trying to modify them
        if (partnerNameDiv && eventTypeOtherDiv) {
            if (selectedValue === 'Wedding') {
                // Show partner name, hide event type other
                partnerNameDiv.style.display = '';
                eventTypeOtherDiv.style.display = 'none';
            } else if (selectedValue === 'Other') {
                // Hide partner name, show event type other
                partnerNameDiv.style.display = 'none';
                eventTypeOtherDiv.style.display = '';
            } else {
                // Hide both for any other selection
                partnerNameDiv.style.display = 'none';
                eventTypeOtherDiv.style.display = 'none';
            }
        }
    }
});
